module.exports = __webpack_public_path__ + "assets/images/popups/loading_ru.png";